import React from 'react';

const ErrorMessage = ({ message }) => {
  return <label style={{color: 'red'}}>{message}</label>
};

export default ErrorMessage;